<template>
  <img src="@/assets/img/banner988.png" alt="">
</template>

<script>
export default {
  name: 'HochuCredit988'
}
</script>
